import React from 'react';

export const CarrouselVisuelsLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
